"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var School_1 = require("./School");
exports.School = School_1.School;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy90ZXN0L1NhbXBsZS9wYXJ0cy9FZHVjYXRpb24vcGFydHMvU2Nob29sL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsbUNBQStCO0FBQXZCLDBCQUFBLE1BQU0sQ0FBQSJ9